import { jsx as _jsx } from "react/jsx-runtime";
import { Box, DropdownButton, InputRichText, Text, } from '@dixa/lib-shared-habla';
import { memo, useCallback, useContext, useMemo, useRef, useState, } from 'react';
import { useCommandHandler } from 'utils/commands';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { CopilotDropdownFeedback, CopilotDropdownRoot, CopilotDropdownTranslate, } from './components';
import { copilotActions } from './utils';
/**
 * Represents a dropdown component designed to be integrated into a rich text
 * editor's toolbar as an addon, providing AI-powered functionalities to enhance
 * and refine the content within the editor.
 */
export const CopilotDropdown = memo(function CopilotDropdown() {
    const flags = useFeatureFlag(['agent-copilot']);
    const [selectedAction, setSelectedAction] = useState();
    const dropdownButtonRef = useRef(null);
    const editor = useContext(InputRichText.Context);
    for (const copilotActionName in copilotActions) {
        const commandName = copilotActions[copilotActionName].commandName;
        if (commandName) {
            // Hooks shouldn't be used inside loops because loops can be dynamic.
            // However, in this use case, the list is fixed, so the loop will always
            // be the same in runtime. Accordingly, using hooks here is safe.
            // eslint-disable-next-line react-hooks/rules-of-hooks
            useCommandHandler({
                name: commandName,
                actionFn: () => {
                    var _a;
                    (_a = dropdownButtonRef.current) === null || _a === void 0 ? void 0 : _a.open();
                    setSelectedAction(copilotActionName);
                },
            });
        }
    }
    const handleDropdownToggle = useCallback((isOpen) => {
        if (isOpen) {
            editor.selection.recreate();
        }
        else {
            setSelectedAction(undefined);
        }
    }, [editor.selection]);
    const dropdownContent = useMemo(() => {
        switch (selectedAction) {
            case 'sendFeedback':
                return _jsx(CopilotDropdownFeedback, {});
            case 'checkSpellingAndGrammar':
                return (_jsx(Text.Heading, { children: _jsx(Box, Object.assign({ padding: "500" }, { children: "Check spelling and grammar (Coming soon)" })) }));
            case 'translate':
                return _jsx(CopilotDropdownTranslate, {});
            default:
                return _jsx(CopilotDropdownRoot, { onSelectionChange: setSelectedAction });
        }
    }, [selectedAction]);
    if (!flags.agentCopilot) {
        return null;
    }
    return (_jsx(DropdownButton, Object.assign({ ref: dropdownButtonRef, fixed: true, noArrow: true, noStyle: true, onToggle: handleDropdownToggle, dropdown: dropdownContent }, { children: _jsx(InputRichText.ToolbarButton, { icon: "ai" }) })));
});
